{
  "s_light": "light",
  "s_dark": "dark",
  "nav_explore": "Zürich erkunden",
  "nav_explore_desc": "Restaurants, Hotels, was man in Zürich und Umgebung unternehmen kann und mehr.",
  "nav_home": "inzh.ch",
  "nav_home_desc": "Info Portal für Zürich und Umgebung",
  "nav_kantonsrat": "Kantonsrat",
  "nav_kantonsrat_desc": "Personen, Sitzungen und Gremien des Zürcher Kantonsrates",
  "nav_about": "Über",
  "nav_about_desc": "Über inzh.ch, Datenschutzerklärung und Impressum",
  "l_expand": "Vollansicht",
  "l_collapse": "Vollansicht schliessen",
  "l_back": "Zurück",
  "l_asceding": "Aufsteigend",
  "l_descending": "Absteigend",
  "l_privacy": "Datenschutz",
  "l_privacy_txt": "inzh.ch speichert ein Cookie, um die Theme Präferenz zu speichern. Die Quellen der interaktiven Karte sowie der Bilder versuchen zusätzlich Cookies von Drittanbietern zu setzen.",
  "l_impressum": "Impressum",
  "l_page_not_found": "Seite nicht gefunden / 404",


  "nav_news": "News und Mitteilungen",
  "nav_news_desc": "News und allgemeine Informationen aus Zürich und darüber hinaus"
  
}